import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { changeSelectedDate } from "../../store/slice/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import en from "date-fns/locale/es";
registerLocale("en", en);

const BookingDatePicker = () => {
  const curentDate = useSelector((state) => state.orderReducer.selectedDate);
  const dispatch = useDispatch();

  const changeDate = (date) => {
    dispatch(changeSelectedDate(date.setHours(0, 0, 0, 0)));
  };

  return (
    <div className="booking-date-picker">
      <DatePicker selected={curentDate ? new Date(curentDate) : Date.now()} onChange={changeDate} minDate={new Date()} maxDate={null} locale="en" inline />
    </div>
  );
};

export default BookingDatePicker;
